import React from 'react'
import icons from '../icons';
import { Link } from 'react-router-dom';
import Footer from '../components/auth/Footer';

export default function NotFound() {
  return (
    <div className="wrapper">
    <div className="sign-page">
      <div className="right-dot"></div>
      <div className="content">
        <div className="flex-warp-block single-input-block">
          <div className="container">
            <div className="logo hide">
              <Link to="/">
              <img src={icons.OPAL_LOGO} alt="Logo" />
            </Link>
            </div>
            <div className="sign-form">
              <h1>Page Not Found</h1>
              <p>Design awaited</p>
              
            </div>

           
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </div>
  )
}
